import { Body2, Button, H4, Modal } from '@/_components';

export default function OverrideConsentModal({ isOpen, onClose }: { isOpen: boolean; onClose: (v: boolean) => void }) {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <H4 className="mt-3">Updating this field will result in loss of information provided by the Customer</H4>

      <Body2 className="mt-4">Do you want to continue?</Body2>

      <div className="mt-6 flex gap-4">
        <Button size="small" variant="contained" onClick={handleClose}>
          No
        </Button>
        <Button
          size="small"
          onClick={() => {
            onClose(true);
          }}
        >
          Yes
        </Button>
      </div>
    </Modal>
  );
}
